import { BASE_URL } from "../api/requests/urls";

export function downloadFile(address) {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);
    fetch(BASE_URL + "/" + decodeURI(address), { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } })

        .then(response => response.blob())
        .then(blobby => {
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = 'device-list.xlsx';
            anchor.click();
            window.URL.revokeObjectURL(objectUrl);
        });
}


export function toPersianNumber(value, grouping = false) {
    return new Number(value).toLocaleString('fa-IR', { useGrouping: grouping })
}

export function toPersianDate(value) {
    return new Date(value).toLocaleDateString('fa-IR')
}


export function toPersianNumberString(n) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return n
        ?.toString()
        ?.replace(/\d/g, x => farsiDigits[x]);
}


export function accountToString(account) {
    return `${account.bank} (${toPersianNumberString(
        account.accountNumber.slice(-5)
    )})`
}